var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"s-role-list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"s-role-list-item",style:({
         ..._vm.bgStyle,
         'background-image': `url(${item.bg})`
       })},[_c('img',{staticClass:"s-role-list-item-img",class:_vm.animateMap[_vm.animateType],style:(_vm.coverStyle),attrs:{"src":item.cover,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }